<template>
	<div class="card">
		<div class="card-header bg-dark">
			<h3 class="mb-0 text-white">
				รายการฝาก/ถอนรายบุคคล
			</h3>
		</div>

		<el-table row-key="id" header-row-class-name="thead-light" :data="queriedData">
			<el-table-column label="สมาชิก" min-width="100px">
				<div slot-scope="{ row }">
					<router-link :to="`/dashboard/members?search=${row.member.phone}`">
						{{ row.member.firstName }} {{ row.member.lastName }}
					</router-link>
					<br />
					{{ row.member.phone }}
				</div>
			</el-table-column>
			<el-table-column label="ยอดฝาก" min-width="100px">
				<div slot-scope="{ row }">
					<b>{{ row.deposit | format }}</b> บาท
					<small>({{ row.depositCount }} ครั้ง)</small>
				</div>
			</el-table-column>
			<el-table-column label="ยอดถอน" min-width="100px">
				<div slot-scope="{ row }">
					<b>{{ row.withdraw | format }}</b> บาท
					<small>({{ row.withdrawCount }} ครั้ง)</small>
				</div>
			</el-table-column>
			<el-table-column label="กำไร/ขาดทุน" min-width="100px">
				<div slot-scope="{ row }">
					<b>{{ row.diff | format }}</b> บาท
				</div>
			</el-table-column>
		</el-table>

		<div class="card-footer border-0 d-flex justify-content-between">
			<p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>

			<base-pagination :per-page="pagination.perPage" :total="total" v-model="pagination.currentPage" />
		</div>
	</div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '../../components'

import moment from 'moment'
import BonusService from '../../services/bonus.service'
import tablePagination from '../../mixins/tablePagination'

export default {
	props: ['data', 'orderBy'],
	mixins: [tablePagination([], 10)],
	components: {
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	methods: {
		aggregateData(data) {
			const results = {}
			data.forEach((row) => {
				const memberID = row.member.id
				if (!results.hasOwnProperty(memberID)) {
					results[memberID] = {
						member: row.member,
						deposit: 0,
						depositCount: 0,
						withdraw: 0,
						withdrawCount: 0,
					}
				}

				const ret = results[memberID]
				if (row.type === 'deposit') {
					ret.deposit += row.amount
					ret.depositCount += 1
				} else {
					ret.withdraw += row.amount
					ret.withdrawCount += 1
				}
			})

			const records = []
			for (let x in results) {
				const ret = results[x]

				records.push({
					...ret,
					diff: ret.deposit - ret.withdraw,
				})
			}
			records.sort((a, b) => {
				if (a[this.orderBy] > b[this.orderBy]) return -1
				if (a[this.orderBy] < b[this.orderBy]) return 1
				return 0
			})
			this.updateTableData(records)
		},
	},
	created() {
		this.aggregateData(this.data)
	},
	watch: {
		data(v) {
			this.aggregateData(v)
		},
	},
}
</script>
